/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */
import service from '../../services/zoom';

const ZOOM_RECORDINGS_LOAD = 'ZOOM_RECORDINGS_LOAD';
const ZOOM_RESPONSE_LOAD = 'ZOOM_RESPONSE_LOAD';

const state = {
  zoomResponse: null,
  zoomRecordings: null,
};

const mutations = {
  [ZOOM_RECORDINGS_LOAD] (state, recs) {
    state.zoomRecordings = recs;
  },
  [ZOOM_RESPONSE_LOAD] (state, data) {
    state.zoomResponse = data;
  },
};

const actions = {
  getZoomRecordings: ({ commit }) => {
    return service.getZoomRecordings()
      .then(data => {
        if (typeof data.status !== 'undefined' && data.status === 0) {
          throw new Error('Not logged into Zoom');
        }
        commit(ZOOM_RESPONSE_LOAD, data);
        if (data.meetings) {
          commit(ZOOM_RECORDINGS_LOAD, data.meetings);
        }
        return data;
      });
  },
  saveZoomCode: ({}, code) => {
    return service.saveToken({provider: 'Zoom', code});
  }
};

const getters = {
  zoomRecordings: state => state.zoomRecordings,
  zoomResponse: state => state.zoomResponse,
};

export default {
  state,
  mutations,
  actions,
  getters
};
